import React from 'react'
import CustomerRegisterTable from '../component/CustomerRegisterTable'
export default function RegisterTable() {
  return (
    <div>
      <CustomerRegisterTable/>
    </div>
  )
}
